var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
// import { integrationClientChannelId } from '../axios-client';
import axios from 'axios';
import { B2B_BUILDERTREND_LINK_PATH, B2B_BUILDERTREND_UNLINK_PATH, } from '../../constants/paths';
import { getBuildertrendAxiosClient } from '../axios-client';
/**
 *
 * @param code - is passed from parent function which does the actual call.
 * @returns promise api
 */
export var BuildertrendLinkApi = function (code) {
    return axios
        .create(__assign(__assign({}, getBuildertrendAxiosClient(code)), { responseType: 'json' }))
        .post(B2B_BUILDERTREND_LINK_PATH);
};
/**
 *
 * export const integrationClientChannelId = {
  client: axios.create({ ...integrationClientBase, responseType: 'json' }),
};

 */
export var BuildertrendUnlinkApi = function (userType) {
    return axios
        .create(__assign(__assign({}, getBuildertrendAxiosClient('')), { responseType: 'json' }))
        .delete("".concat(B2B_BUILDERTREND_UNLINK_PATH, "?requestType=").concat(userType || 'user'));
};
